import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index/index.vue'),
    meta: { bg: 'bg-1' }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/index/home.vue'),
    meta: { loginRequired: true }
  },
  {
    path: '/empty',
    name: 'empty',
    component: () => import('../views/index/empty.vue'),
    meta: {}
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/index/service.vue')
  },
  {
    path: '/start',
    name: 'start',
    component: () => import('../views/booking/start.vue'),
    meta: { loginRequired: true }
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/booking/order.vue'),
    meta: { loginRequired: true }
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('../views/user/mine.vue'),
    meta: { loginRequired: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/user/login.vue'),
    meta: { bg: 'bg-1' }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/user/register.vue'),
    meta: { bg: 'bg-1' }
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('../views/user/invite.vue'),
    meta: { loginRequired: true }
  },
  {
    path: '/vip',
    name: 'vip',
    component: () => import('../views/user/vip.vue'),
    meta: { loginRequired: true }
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: () => import('../views/account/withdraw.vue'),
    meta: { loginRequired: true, bg: 'bg-3' }
  },
  {
    path: '/withdraw/history',
    name: 'withdrawHistory',
    component: () => import('../views/account/withdrawHistory.vue'),
    meta: { loginRequired: true }
  },
  {
    path: '/bind',
    name: 'bind',
    component: () => import('../views/account/bind.vue'),
    meta: { loginRequired: true, bg: 'bg-3' }
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: () => import('../views/account/recharge.vue'),
    meta: { loginRequired: true, bg: 'bg-3' }
  },
  {
    path: '/account/logs',
    name: 'accountLogs',
    component: () => import('../views/account/accountLogs.vue'),
    meta: { loginRequired: true }
  },
  {
    path: '/fundpwd',
    name: 'fundpwd',
    component: () => import('../views/set/fundpwd.vue'),
    meta: { loginRequired: true, bg: 'bg-3' }
  },
  {
    path: '/loginpwd',
    name: 'loginpwd',
    component: () => import('../views/set/loginpwd.vue'),
    meta: { loginRequired: true, bg: 'bg-3' }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/article/about.vue'),
    meta: { loginRequired: true }
  },
  {
    path: '/event',
    name: 'event',
    component: () => import('../views/article/event.vue')
  },
  {
    path: '/FAQs',
    name: 'FAQs',
    component: () => import('../views/article/faqs.vue'),
    meta: { loginRequired: true }
  },
  {
    path: '/terms/privacy',
    name: 'termsPrivacy',
    component: () => import('../views/article/termsPrivacy.vue')
  },
  {
    path: '/terms/register',
    name: 'termsRegister',
    component: () => import('../views/article/termsRegister.vue')
  },
  {
    path: '/cert',
    name: 'cert',
    component: () => import('../views/article/cert.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
    if(to.meta.bg) {
        document.body.classList = to.meta.bg
    }else {
        document.body.classList = ''
    }
    next()
})

export default router
